import dayjs, { Dayjs } from 'dayjs';

import { ConvertableToDateTime, TimeUnit } from '@cast/shared-types';

type DateRangeIteratorOptions = {
  unit?: TimeUnit;
  step?: number;
};

export function* dateRangeIterator(
  from: ConvertableToDateTime,
  to: ConvertableToDateTime,
  options: DateRangeIteratorOptions = {}
): Generator<Dayjs> {
  const { unit = 'day', step = 1 } = options;
  from = dayjs(from);
  to = dayjs(to);
  let current = from;
  if (from.isBefore(to, unit)) {
    while (current.isBefore(to, unit) || current.isSame(to, unit)) {
      yield current;
      current = current.add(step, unit);
    }
  } else if (from.isAfter(to, unit)) {
    while (current.isAfter(to, unit) || current.isSame(to, unit)) {
      yield current;
      current = current.subtract(step, unit);
    }
  } else if (from.isSame(to, unit)) {
    yield to;
  }
}

export const timeRange = (
  from: ConvertableToDateTime,
  to: ConvertableToDateTime,
  options?: DateRangeIteratorOptions
): Dayjs[] => Array.from(dateRangeIterator(from, to, options));
